import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card } from '@/components/ui/Card';
import { api } from '@/lib/api';

type State = 'pending' | 'ok' | 'fail';

export function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState<State>('pending');
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    if (!token) {
      setState('fail');
      setMessage('退订链接无效');
      return;
    }
    void api
      .get<{ ok: true } | unknown>(
        `/unsubscribe?token=${encodeURIComponent(token)}`,
        { auth: false },
      )
      .then(() => {
        setState('ok');
        setMessage('已退订观微邮件推送');
      })
      .catch((err) => {
        setState('fail');
        setMessage((err as Error).message ?? '退订失败');
      });
  }, [token]);

  return (
    <main className="flex-1 flex items-center justify-center px-6">
      <Card className="p-10 text-center max-w-md">
        <p className="font-serif text-2xl text-fg mb-3">
          {state === 'pending' ? '处理中…' : state === 'ok' ? '已退订' : '退订失败'}
        </p>
        <p className="text-sm text-fg-2 mb-6">{message}</p>
        {state === 'ok' && (
          <p className="text-xs text-fg-muted">
            随时可以在{' '}
            <Link to="/settings/push" className="text-accent">
              推送设置
            </Link>
            重新订阅
          </p>
        )}
      </Card>
    </main>
  );
}
